<template>

  <div class="card">
    <div class="card-header">Agentes</div>
    <div class="card-body">
      <table class="table table-hover">
        <thead>
          <th>Nombre</th>
          <th>Correo</th>
          <th>Teléfono</th>
        </thead>
        <tbody>
          <tr class="text-center" v-for="agent in agents">
            <td>{{agent.name}}</td>
            <td>{{agent.email}}</td>
            <td>{{agent.phone}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'supplier-agents',
    props: ['id_supplier', 'usuario'],
    mounted() {
      axios.get('/api/supplier/admin/agents/' + this.id_supplier).then(response => {
        this.agents = response.data
      })
    },
    data() {
      return {
        agents: []
      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .supplier-agents {

  }
</style>
